<template>
    <v-app>
      <v-container :style="{ background: randomBackground }" class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" lg="4">
            <v-card class="elevation-12 login-card">
              <v-card-title class="headline text-center">{{ $t('agentLogin.title') }}</v-card-title>
              <v-card-actions>
                <v-btn v-if="network" @click="toggleNetworkDialog">{{ $t('agentLogin.switchNetwork') }}</v-btn>
              </v-card-actions>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-btn
                    class="agent-connect-wallet-btn"
                    @click="toggleWalletConnection"
                    block
                    large
                  >
                    <v-icon left>mdi-wallet</v-icon>
                    {{ $t('agentLogin.connectWallet') }}
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <network-switch-dialog ref="networkDialog"></network-switch-dialog>
    </v-app>
  </template>
  
  <script>
  // import WalletConnect from '@/utils/walletConnect';
  import NetworkSwitchDialog from '@/components/NetworkSwitchDialog';
  import { mapState } from 'vuex';
  export default {
    components: {
      NetworkSwitchDialog
    },
    props: {
      walletConnect: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        valid: false,
        network: false,
        // walletConnect: null, // Store the WalletConnect instance
        loading: false, // Loading state
        randomBackground: '', // Random background style
      };
    },
    computed: {
      ...mapState(['isUserLoggedIn', 'isAgent']),
    },
    mounted() {
      // this.walletConnect = new WalletConnect(this.$router, this.setLoading);
      if(localStorage.getItem('networkSwitch')) {
        this.network = true;
      }
      localStorage.setItem('firstReloadState', false);
      this.checkLoginStatus();
      this.setRandomBackground();
    },
    methods: {
      checkLoginStatus() {
        if (this.isUserLoggedIn && this.isAgent) {
          this.$router.push('/dashboard');
        }
      },
      toggleNetworkDialog() {
        this.$refs.networkDialog.dialog = true;
      },
      async toggleWalletConnection() {
        if (this.walletConnect) {
          this.setLoading(true);
          this.walletConnect.toggleConnect().finally(() => {
            this.setLoading(false);
          });
          
        } else {
          console.error('WalletConnect instance is not initialized.');
        }
      },
      setLoading(value) {
        this.loading = value;
        if(value){
          this.$toast.showMarkLoading();
        } else {
          this.$toast.hideMarkLoading();
        }
      },
      setRandomBackground() {
        const colors = [
          ['#4a90e2', '#9013fe'],
          ['#ff6b6b', '#f06595'],
          ['#34e89e', '#0f3443'],
          ['#ff9a9e', '#fad0c4'],
          ['#fbc2eb', '#a6c1ee'], // Light pink to light blue
          ['#ffecd2', '#fcb69f'], // Light peach to orange
          ['#a1c4fd', '#c2e9fb'], // Light blue to lighter blue
          ['#d4fc79', '#96e6a1'], // Light green to mint
          ['#84fab0', '#8fd3f4'], // Mint to light blue
        ];
        const randomIndex = Math.floor(Math.random() * colors.length);
        this.randomBackground = `linear-gradient(to bottom right, ${colors[randomIndex][0]}, ${colors[randomIndex][1]})`;
      },
    },
  };
  </script>
  
  <style scoped>
.fill-height {
  position: relative;
  overflow: hidden;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  background-color: #f7f9fc;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  max-width: 450px;
  margin: auto;
  padding: 30px;
  border: 1px solid #e0e0e0;
}

.v-btn {
  margin-top: 20px;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(45deg, #ff6b6b, #f06595);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  transition: background 0.3s ease, transform 0.2s ease;
}

.v-btn:hover {
  background: linear-gradient(45deg, #f06595, #ff6b6b);
  transform: translateY(-2px);
}

.v-overlay {
  background-color: rgba(255, 255, 255, 0.8);
  color: #000;
}
  </style>